module.exports = __webpack_public_path__ + "media/Break_the_Faith_Solo-low_res.02d352a8.mp4";